import {findContainer, getDataAttributes, getSystemTheme, setParamArray, mergeDeepObject} from "./_util";

const VGMap = {
    isDebug: false,
    controls: [
        'geolocationControl',
        'searchControl',
        'typeSelector',
        'fullscreenControl',
        'scrollZoom'
    ],
    breakpoints: {
        xs: 0,
        sm: 640,
        md: 767,
        lg: 991,
        xl: 1199,
        xxl: 1399,
        xxxl: 1599
    },

    init: function (map, arg = {}) {
        if (!map) {
            VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
            return false;
        }

        let isYaMaps = true;
        try {
            if (ymaps) isYaMaps = true;
        } catch (e) {
            isYaMaps = false;
        }

        if (!isYaMaps) {
            VGLog("error", ["Не возможно запустить сервис API Яндекс.Карт!"]);
            return false;
        }

        let params = {
            controls: [],
            zoom: 15,
            theme: 'light',
            offset: {
                x: [0],
                y: [0]
            },
            sizes: {
                width: [],
                height: []
            },
            permission: {
                isClustered: false,
                isScrollZoom: false,
                isBalloon: false,
                isHint: false,
                isTheme: false
            },
            marker: {
                type: 'default',
                color: App.themeColor,
                custom: {}
            },
            cluster: {
                icon: {
                    color: App.themeColor || '#ffffff'
                }
            }
        }, dataParams = {};

        if (typeof map === 'string') {
            params.map = findContainer('#' + map);
            params.id = map;

            if (params.map) dataParams = getDataAttributes(params.map, true);
        } else if (typeof map === 'object') {
            let target = map.getAttribute('id') || null;

            if (!target) {
                VGLog("error", ["Мон Синьор! Путь к карте не найден"]);
                return false;
            }

            params.id = target;
            params.map = findContainer('#' + target);
            dataParams = getDataAttributes(map, true);
        } else {
            VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
            return false;
        }

        if (!params.map) {
            VGLog("error", ["Сударь! А где, собственно, карта?"]);
            return false;
        }

        params = mergeDeepObject(params, arg, dataParams);

        if ('vg-map' in params) {
            params.isGlobalInit = true;
            delete params['vg-map'];
        }

        /* если много точек на карте */
        if ('points' in params) {
            if (typeof params.points === "string") {
                params.points = JSON.parse(params.points);
            }
        }

        /* размер карты */
        if ('height' in params) {
            params.sizes.height = setParamArray(params.height, true);
            delete params['height'];
        }

        if ('width' in params) {
            params.sizes.width = setParamArray(params.width, true);
            delete params['width'];
        }

        /* смещение карты */
        if ('offset-y' in params) {
            params.offset.y = setParamArray(params['offset-y'], true);
            delete params['offset-y'];
        }
        if ('offset-x' in params) {
            params.offset.x = setParamArray(params['offset-x'], true);
            delete params['offset-x'];
        }

        /* Zoom */
        if ('zoom' in params) {
            params.zoom = parseInt(params['zoom']);
        }

        /* тип маркера */
        if ('marker-custom' in params) {
            params.marker.type = 'custom';

            if (typeof params['marker-custom'] === 'string') {
                params.marker.custom = JSON.parse(params['marker-custom']);
            } else {
                params.marker.custom = params['marker-custom'];
            }

            delete params['marker-custom']
        }

        if ('marker-color' in  params) {
            params.marker.color = params['marker-color'];
            delete params['marker-color']
        }

        if ('marker-type' in  params) {
            params.marker.type = params['marker-type'];
            delete params['marker-type']
        }

        /* Тема: светлая, темная или как в системе. По умолчанию: светлая */
        if ('theme' in params) {
            if (params.theme === 'system') {
                params.theme = getSystemTheme();
            }
        }

        params = this.setPermission(params);
        params.coordinate = this.getCoordinate(params);

        if (this.isDebug) {
            console.log(params);
        }

        this.isInit = true;
        this.run(params, arg.callback);
    },

    setPermission: function (params) {
        /* нужна ли кластеризация */
        if (('isclustered' in params) || ('isClustered' in params) || ('clustered' in params)) {
            params.permission.isClustered = true;
            delete params['isclustered'];
            delete params['clustered'];
            delete params['isClustered'];
        }

        /* нужна ли нам балун */
        if (('isballoon' in params) || ('isBalloon' in params) || ('balloon' in params)) {
            params.permission.isBalloon = true;
            delete params['isballoon'];
            delete params['isBalloon'];
        }

        /* нужен ли зум при скролле */
        if (('is-scroll-zoom' in params) || ('isScrollZoom' in params) || ('isscrollzoom' in params)) {
            params.permission.isScrollZoom = true;
            delete params['is-scroll-zoom'];
            delete params['isscrollzoom'];
            delete params['isScrollZoom'];
        }

        /* нужна ли нам хинт */
        if ('hint' in params) {
            params.permission.isHint = true;
        }

        /* Тема оформления карты. На данный момент доступно: grayscale */
        if ('theme' in params && params.theme.length) {
            params.permission.isTheme = true;
        }

        return params;
    },

    getCoordinate: function (params) {
        let coordinate = [];

        if ((!params.lat && !params.lon) && ('points' in params)) {
            if (params.points.length && !(params.lat && params.lon)) {
                for (let i = 0; i < params.points.length; i++) {
                    if (('lat' in params.points[i]) && ('lon' in params.points[i])) {
                        if (i === 0) {
                            coordinate.push(params.points[i].lat)
                            coordinate.push(params.points[i].lon)
                        }
                    }
                }
            }
        } else if (params.lat && params.lon) {
            coordinate.push(params.lat);
            coordinate.push(params.lon);

            delete params.lon;
            delete params.lat;
        }

        return coordinate;
    },

    run: function (params, callback) {
        if (!this.isInit) return false;

        const _this = this;

        if (callback) {
            /* колбек после инициализации скрипта, возвращаем объект, разрешения и полученные параметры  */
            if (typeof callback.afterInit === 'function') {
                callback.afterInit(_this, params)
            }
        }

        VGMap.Map.size(params);

        if (params.coordinate.length) {
            ymaps.ready(init);

            function init() {
                if (!params.isGlobalInit) {
                    VGMap.Map.set(params, callback);
                } else {
                    let map = VGMap.Map.set(params, callback);
                    VGMap.PlaceMark.set(map, params);
                    VGMap.Map.offset(map, params);
                }
            }
        } else {
            VGLog("error", ["Ахпер! Гдэ координаты, для карты #" + params.id + "!"]);
            return false;
        }
    },

    Map: {
        set: function (params, callback) {
            let permission = params.permission;

            let map = new ymaps.Map(params.id, {
                center: params.coordinate,
                zoom: params.zoom,
                controls: ['smallMapDefaultSet'],
            }, {
                searchControlProvider: 'yandex#search',
                suppressMapOpenBlock: true,
            });

            /* Отключаем не нужное. Передаем в массив (дата аттрибут), то что не нужно отключать, если нужно отключить всё оставляем пустым */
            VGMap.Map.disabled(map, params.controls);

            if (!permission.isScrollZoom) {
                map.behaviors.disable('scrollZoom');
            }

            if (window.innerWidth < 1000) {
                map.behaviors.get('drag').disable();
            }

            if (permission.isTheme) {
                let MAP = 'custom#' + params.theme;

                ymaps.layer.storage.add(MAP, function mapLayer() {
                    return new ymaps.Layer('https://core-renderer-tiles.maps.yandex.net/tiles?l=map' + ((params.theme == 'dark') ? ('&theme=dark') : ('')) + '&%c&%l');
                });
                ymaps.mapType.storage.add(MAP, new ymaps.MapType(params.theme, [MAP]));
                map.setType(MAP);
            }

            if (callback) {
                /* колбек после инициализации карты, возвращаем карту и полученные параметры  */
                if (typeof callback.afterInitMap === 'function') {
                    return callback.afterInitMap(map, params, VGMap)
                }
            }

            return map;
        },

        size: function (params) {
            // todo тут где то есть jquery
            const $map = $(params.map);

            setParamSizes('height', $map.height());
            //setParamSizes('width', $map.width());

            let width = params.sizes.width,
                height = params.sizes.height;

            VGMap.Map.setBreakpoints(setSizes);

            function setSizes(index) {
                let _width = width[index],
                    _height = height[index];

                if (_width === undefined) {
                    _width = width[width.length - 1];
                }

                if (_height === undefined) {
                    _height = height[height.length - 1];
                }

                $map.css('height', _height);
                $map.css('width', _width);
            }

            function setParamSizes(side, value) {
                if (side in params.sizes) {
                    let aSide = params.sizes[side]

                    if (!aSide.length) {
                        if (value === 0) {
                            params.sizes[side].push(VGMap.size[side]);
                        } else {
                            params.sizes[side].push(value);
                        }
                    }
                }
            }
        },

        disabled: function (map, items = []) {
            // todo тут jquery
            if (items.length > 0) {
                $.each(items, function (i, val) {
                    if (VGMap.controls.indexOf(val) > -1) {
                        delete VGMap.controls[i];
                    }
                });
            }

            $.each(VGMap.controls, function (i, val) {
                if (val !== 'undefined') {
                    map.controls.remove(val);
                }
            });
        },

        offset: function (map, params) {
            let offsetX = params.offset.x,
                offsetY = params.offset.y;

            VGMap.Map.setBreakpoints(setOffset);

            function setOffset(index) {
                let x = offsetX[index],
                    y = offsetY[index];

                if (x === undefined) {
                    x = offsetX[offsetX.length - 1];
                }

                if (y === undefined) {
                    y = offsetY[offsetY.length - 1];
                }

                let position = map.getGlobalPixelCenter();
                map.setGlobalPixelCenter([position[0] - x, position[1] - y]);
            }
        },

        setBreakpoints: function (func, width = null) {
            if (width) {
                let _breakpoints = Object.keys(VGMap.breakpoints);

                for (let i = 0; i < _breakpoints.length; i++) {
                    if (width <= VGMap.breakpoints[_breakpoints[i]]) {
                        func(i)
                    }
                }
            } else {
                if (window.innerWidth <= VGMap.breakpoints['sm']) {
                    func(0);
                } else if (window.innerWidth >= VGMap.breakpoints['sm'] && window.innerWidth <= VGMap.breakpoints['md']) {
                    func(1);
                } else if (window.innerWidth >= VGMap.breakpoints['md'] && window.innerWidth <= VGMap.breakpoints['lg']) {
                    func(2);
                } else if (window.innerWidth >= VGMap.breakpoints['lg'] && window.innerWidth <= VGMap.breakpoints['xl']) {
                    func(3);
                } else if (window.innerWidth >= VGMap.breakpoints['xl'] && window.innerWidth <= VGMap.breakpoints['xxl']) {
                    func(4);
                } else if (window.innerWidth >= VGMap.breakpoints['xxl']) {
                    func(5);
                }
            }
        }
    },

    PlaceMark: {
        set: function (map, params) {
           if ('points' in params) {
               let points = [];

               for (let i = 1; i <= params.points.length; i++) {
                   let makerIndex = 0,
                       point = params.points[i - 1];

                   if (params.mark === 'points') {
                       makerIndex = [i - 1]
                   }

                   if (params.marker.type === 'default') {
                       points.push(
                           new ymaps.Placemark(
                               [point.lat, point.lon],
                               VGMap.PlaceMark.ballon(params, point),
                               VGMap.PlaceMark.marker('default', point.color))
                       );
                   } else if(params.marker.type === 'custom') {
                       points.push(
                           new ymaps.Placemark(
                               [point.lat, point.lon],
                               VGMap.PlaceMark.ballon(params, point),
                               VGMap.PlaceMark.marker('custom', point))
                       );
                   }
               }

               if (params.permission.isClustered) {
                   let cluster = new ymaps.Clusterer({
                       clusterIconColor: params.cluster.icon.color,
                       clusterHideIconOnBalloonOpen: false,
                       geoObjectHideIconOnBalloonOpen: false,
                   });

                   cluster.add(points);

                   map.geoObjects.add(cluster);
                   map.setBounds(cluster.getBounds());
               } else {
                   let pointCollection = new ymaps.GeoObjectCollection();

                   for (let i in points) {
                       pointCollection.add(points[i]);
                   }

                   map.geoObjects.add(pointCollection);
                   map.setBounds(map.geoObjects.getBounds());
               }
           } else {
               let marker;

               if (params.marker.type === 'default') {
                   marker = new ymaps.Placemark(
                       map.getCenter(),
                       VGMap.PlaceMark.ballon(params),
                       VGMap.PlaceMark.marker('default', params.marker.color)
                   );
               } else if (params.marker.type === 'custom') {
                   marker = new ymaps.Placemark(
                       map.getCenter(),
                       VGMap.PlaceMark.ballon(params),
                       VGMap.PlaceMark.marker('custom', params.marker.custom)
                   );
               }

               map.geoObjects.add(marker);
           }

            map.events.add('click', e => e.get('target').balloon.close());
        },

        marker: function (type, point) {
            if (type === 'default') {
                return VGMap.PlaceMark.createDefaultMarker(point);
            } else if (type === 'custom') {
                return VGMap.PlaceMark.createCustomMarker(point)
            }
        },

        createCustomMarker: function (mark) {
            let marker = {};

            if ('src' in mark) {
                marker.iconLayout = 'default#image';
                marker.iconImageHref = mark.src;
            }

            if ('size' in mark) {
                marker.iconImageSize = mark.size;
            }

            if ('offset' in mark) {
                marker.iconImageOffset = mark.offset;
            }

            return marker;
        },

        createDefaultMarker: function (color) {
            let defaultMarkerIcon = '<div style="position: absolute; top: -67px; left: calc(-1 * (58px/2))"><svg width="58" height="67" viewBox="0 0 58 67" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<g clip-path="url(#clip0_1314_8)">\n' +
                    '<g filter="url(#filter0_d_1314_8)">\n' +
                    '<path d="M34.342 49.376C31.266 50.306 29.655 52.355 29.511 55.523C29.5051 55.6516 29.4498 55.7729 29.3567 55.8618C29.2635 55.9506 29.1397 56.0001 29.011 56H28.989C28.8603 56.0001 28.7365 55.9506 28.6433 55.8618C28.5502 55.7729 28.4949 55.6516 28.489 55.523C28.345 52.355 26.734 50.306 23.658 49.376C13.53 46.968 6 37.863 6 27C6 14.297 16.297 4 29 4C41.703 4 52 14.297 52 27C52 37.863 44.469 46.968 34.342 49.376Z" fill="' + color + '"/>\n' +
                    '</g>\n' +
                    '<path d="M29 67C27.9391 67 26.9217 66.5786 26.1716 65.8284C25.4214 65.0783 25 64.0609 25 63C25 61.9391 25.4214 60.9217 26.1716 60.1716C26.9217 59.4214 27.9391 59 29 59C30.0609 59 31.0783 59.4214 31.8284 60.1716C32.5786 60.9217 33 61.9391 33 63C33 64.0609 32.5786 65.0783 31.8284 65.8284C31.0783 66.5786 30.0609 67 29 67Z" fill="white"/>\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M29 65C29.5304 65 30.0391 64.7893 30.4142 64.4142C30.7893 64.0391 31 63.5304 31 63C31 62.4696 30.7893 61.9609 30.4142 61.5858C30.0391 61.2107 29.5304 61 29 61C28.4696 61 27.9609 61.2107 27.5858 61.5858C27.2107 61.9609 27 62.4696 27 63C27 63.5304 27.2107 64.0391 27.5858 64.4142C27.9609 64.7893 28.4696 65 29 65Z" fill="' + color + '"/>\n' +
                    '</g>\n' +
                    '<defs>\n' +
                    '<filter id="filter0_d_1314_8" x="0" y="0" width="58" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
                    '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
                    '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
                    '<feOffset dy="2"/>\n' +
                    '<feGaussianBlur stdDeviation="3"/>\n' +
                    '<feColorMatrix type="matrix" values="0 0 0 0 0.4 0 0 0 0 0.396078 0 0 0 0 0.380392 0 0 0 0.2 0"/>\n' +
                    '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1314_8"/>\n' +
                    '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1314_8" result="shape"/>\n' +
                    '</filter>\n' +
                    '<clipPath id="clip0_1314_8">\n' +
                    '<rect width="58" height="67" fill="white"/>\n' +
                    '</clipPath>\n' +
                    '</defs>\n' +
                    '</svg></div>\n',
                defaultMarkerIconContent = ymaps.templateLayoutFactory.createClass(defaultMarkerIcon);

            return {
                iconLayout: defaultMarkerIconContent,
            }
        },

        ballon: function (params, point = {}) {
            let content = {}, obj = {};

           if (params.permission.isBalloon) {
                if ('balloon-content' in params) {
                    obj = params['balloon-content'];
                } else if ('balloon-content' in point) {
                    obj = point['balloon-content'];
                }

                if (obj) {
                    content = {
                        balloonContent: obj
                    }
                }
            }

            if ('title' in point) {
                content['hintContent'] = point['title'];
            }

            if (params.permission.isHint) {
                if ('hint' in params) {
                    content['hintContent'] = params['hint'];
                }
            }

            return content;
        }
    },

    Location: {
        init: function (callback) {
            let isYaMaps = true;
            try {
                if (ymaps) isYaMaps = true;
            } catch (e) {
                isYaMaps = false;
            }

            if (!isYaMaps) {
                VGLog("error", ["Не возможно запустить сервис API Яндекс.Карт!"]);
                return false;
            }

            ymaps.ready(function () {
                let geolocation = ymaps.geolocation;

                geolocation.get({
                    provider: 'browser'
                }).then(function (result) {
                    if (typeof callback === "function") {
                        callback(result);
                    }
                }, function (err) {
                    console.error(err);

                    geolocation.get({
                        provider: 'yandex'
                    }).then(function (result) {
                        if (typeof callback === "function") {
                            callback(result);
                        }
                    }, function (err) {
                        console.error(err);
                    });
                });
            });

            return false;
        }
    }
}

export default VGMap;
